// Odds API bookmaker keys → the name a person would say. Shared by the list and
// the strip so the two never disagree about what a book is called.
export const BOOKMAKER_NAMES = {
  betmgm: "BetMGM",
  betonlineag: "BetOnline",
  draftkings: "DraftKings",
  espnbet: "ESPN BET",
  fanduel: "FanDuel",
  kalshi: "Kalshi",
  lowvig: "LowVig",
  novig: "NoVig",
  pinnacle: "Pinnacle",
  polymarket: "Polymarket",
  prophetx: "ProphetX",
  williamhill_us: "Caesars",
};
